import { Container } from "react-bootstrap"
import { Route, Switch, useRouteMatch  } from "react-router-dom";
import AddDoctor from "./doctor/AddDoctor";
import DoctorList from "./doctor/DoctorList";
import MisPacientes from "./doctor/MisPacientes";

import '../styles/selectStyles.css'
import '../styles/images.css'
import Trazabilidad from "./Trazabilidad";
import DoctorAgenda from "./doctor/DoctorAgenda";

function DoctorIndex(){
    let { path, url } = useRouteMatch();
    return(
        <Container fluid className="my-5">
            <Switch>
                <Route exact path={path}><DoctorList url={url}/></Route>
                <Route exact path={`${path}/create`}><AddDoctor /></Route>
                <Route exact path={`${path}/doctors/patients/:doctorID`}><MisPacientes /></Route>
                <Route exact path={`${path}/trazabilidad/:id`}><Trazabilidad paciente={false} /></Route>
                <Route exact path={`${path}/doctoragenda/:id`}><DoctorAgenda /></Route>
            </Switch>
        </Container>
    )
}

export default DoctorIndex